import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  AlertDialogPortal,
  AlertDialogTitle,
  AlertDialogTrigger,
} from "@/components/ui/alert-dialog";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { useIsMobile } from "@/hooks/use-mobile";
import { OpportunityContactType } from "@/lib/validations/schema";
import { ColumnDef } from "@tanstack/react-table";
import { AxiosRequestConfig } from "axios";
import { LEVEL_2 } from "common/constants";
import {
  channel_options,
  close_reason_options,
  customer_status_options,
} from "common/filters";
import { checkLevel } from "common/rules";
import { Img, SelectBox, Spinner, Text } from "components";
import NavbarWithActions from "components/Navbar/navbarwithactions";
import { DataTableColumnHeader } from "components/Table/data-table-column-header";
import { DataTable } from "components/Table/DataTable";
import { ArrowUpRight, CircleCheck } from "lucide-react";
import DocumentModal from "models/DocumentPopup";
import LinkCorporate from "models/LinkCorporate";
import LinkPartner from "models/LinkPartner";
import { ChannelOptions } from "pages/Leads/lead";
import EditForm from "pages/Opportunities/editform";
import { LeadOverView } from "pages/Opportunities/LeadOverView";
import MobileCustomerDetails from "pages/Opportunities/MobilecustomerDetails";
import {
  RowDetailsSheet,
  stageTags,
} from "pages/Opportunities/opportunitydetails";
import {
  buttonInfo,
  formatUnixTimestamp,
  getRelativeDate,
} from "pages/Opportunities/utils/featureRule";
import React, { useEffect } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { AiOutlineCloseCircle } from "react-icons/ai";
import { FaFingerprint } from "react-icons/fa";
import { useNavigate, useParams } from "react-router-dom";
import {
  setResumeRegistration,
  setIsReferralMade,
  setPhone,
  setEmail,
  setContactId,
} from "redux/features/CustomerRegistration";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import {
  getStaffCustomer,
  GetStaffCustomerRequestType,
  putCustomerStatus,
  PutCustomerStatusRequestType,
} from "service/apis/CustomerDetailsapi";
import {
  PutUpdateCustomerDetails,
  PutUpdateCustomerDetailsReqType,
} from "service/apis/CustomerRegistrationapi";
import {
  downloadDoc,
  getOpportunityByCompany,
  GetOpportunityByCompanyReqType,
  GetOpportunityByIdReqType,
} from "service/apis/Opportunities";
import { toast } from "sonner";
import { Capitalize } from "utils";

const statusOptionsList = [
  { label: "Pending", value: "pending", bgColor: "#edf89c" },
  { label: "Active", value: "active", bgColor: "#E1FFE2" },
  {
    label: "Conditional Active",
    value: "conditional active",
    bgColor: "#d4fda9",
  },
  { label: "Blocked ", value: "blocked", bgColor: "#f43f5e" },
  { label: "Archieved", value: "archieved", bgColor: "#d2d2d0" },
];

type CustomerDetailsType = {
  id: number;
  full_name: string;
  phone_number: string;
  email: string;
  last_kyc: string;
  status: string;
  pan_no: string;
  pan_soft_copy: {
    url: string;
  };
  aadhaar_soft_copy_front: {
    url: string;
  };
  aadhaar_no: string;
  address_line_1: string;
  address_line_2: string;
  city: string;
  state: string;
  pincode: string;
  kyc_status: string;
  bank_account_number: string;
  bank_name: string;
  ifsc_code: string;
  linked_contact_id: number;
  created_at: number;
  companyDetail: {
    entity_name: "";
    id: 0;
  };
  contactDetails: {
    notes: string;
    id: number;
    linked_company_id: number;
    linked_partner_id: number;
    updated_at: number;
    companyDetail: {
      company_name: string;
      id: number;
    };
    partnerDetail: {
      name: string;
      id: number;
    };
    updatedBy: {
      id: number;
      fname: string;
    };
  };
};
const CustomerDetailsPage: React.FC = () => {
  const tablist = [
    { label: "Leads", value: "leads", enabled: true },
    { label: "Orders", value: "orders", enabled: false },
  ];

  const { id } = useParams();
  const [customerDetails, setCustomerDetails] =
    React.useState<CustomerDetailsType>({
      id: 0,
      full_name: "",
      phone_number: "",
      email: "",
      last_kyc: "",
      status: "",
      pan_no: "",
      pan_soft_copy: {
        url: "",
      },
      aadhaar_soft_copy_front: {
        url: "",
      },
      aadhaar_no: "",
      address_line_1: "",
      address_line_2: "",
      city: "",
      state: "",
      pincode: "",
      kyc_status: "",
      bank_account_number: "",
      bank_name: "",
      ifsc_code: "",
      linked_contact_id: 0,
      created_at: 0,
      companyDetail: {
        entity_name: "",
        id: 0,
      },
      contactDetails: {
        notes: "",
        id: 0,
        linked_company_id: 0,
        updated_at: 0,
        linked_partner_id: 0,
        companyDetail: {
          company_name: "",
          id: 0,
        },
        partnerDetail: {
          name: "",
          id: 0,
        },
        updatedBy: {
          id: 0,
          fname: "",
        },
      },
    });
  const [updatestatus, setUpdatestatus] = React.useState("");
  const [showimg, setShowimg] = React.useState(false);
  const [imgsrc, setImgsrc] = React.useState("");
  const [companyData, setCompanyDetails] = React.useState<any>([]);
  const [dialogOpen, setDialogOpen] = React.useState<boolean>(false);
  const { pipelineType } = useAppSelector((state) => state.CreateOpportunity);
  const [inputValue, setInputValue] = React.useState(
    customerDetails?.contactDetails?.notes || ""
  );
  const [docs, setDocs] = React.useState<
    {
      doc_id: string;
      filename: string;
      file: string;
      date: string;
    }[]
  >([]);
  const [isEditing, setIsEditing] = React.useState(false);
  const [activeTab, setActiveTab] = React.useState("leads");
  const [opportunityList, setOpportunityList] =
    React.useState<OpportunityContactType>([]);
  const [isRowDetailsOpen, setIsRowDetailsOpen] = React.useState(false);
  const [customerLeadList, setCustomerLeadList] =
    React.useState<OpportunityContactType>([]);
  const [selectedRowData, setSelectedRowData] =
    React.useState<OpportunityContactType | null>(null);
  const [OrderList, setOrderListList] = React.useState([]);
  const [loading, setLoading] = React.useState(false);

  const handleEditClick = () => {
    setInputValue(customerDetails?.notes || "");
    setIsEditing(true);
  };

  const methods = useForm({
    defaultValues: companyData,
  });

  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  React.useLayoutEffect(() => {
    const localAppId = localStorage.getItem("ApplicationId");
    const reloadFlag = localStorage.getItem("AlreadyReloaded");

    if (
      customerDetails?.id != null &&
      localAppId != null &&
      customerDetails.id.toString() !== localAppId &&
      reloadFlag !== "true"
    ) {
      localStorage.setItem("AlreadyReloaded", "true");
      window.location.reload();
    }
  }, [customerDetails?.id]);

  React.useEffect(() => {
    if (updatestatus !== "") {
      updateCustomerStatus();
    }
  }, [updatestatus]);

  const fetchPartnerDetails = () => {
    setLoading(true);

    const auth: string | null = localStorage.getItem("authToken");
    if (auth === null) return null;
    const authToken = JSON.parse(auth);
    const payload: AxiosRequestConfig<GetStaffCustomerRequestType> = {
      data: {
        customers_id: id,
      },
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    };

    getStaffCustomer(payload)
      .then((res) => {
        setCustomerDetails(res.data?.customerDetail);
        setOrderListList(() =>
          res.data?.orderList?.map((item: any) => ({
            id: item?.id,
            product: item?._opportunity?.[0]?._product?.name,
            subCategory: item?._opportunity?.[0]?._product?.subCategory,
            assignedTo: item?._opportunity?.[0]?.assignedTo?.fname,
            createDate: getRelativeDate(item?.created_at),
            source:
              item?._opportunity?.[0]?._channel_of_interaction?.[0]?.Channel,
            createdBy: item?.createdBy !== 0 ? item?._createdBy?.fname : name,
            status: item.status,
            location: item?._staff?.city,
            lead_deatils: item?._opportunity?.[0]?._channel_of_interaction?.[0],
          }))
        );

        // lead details list based on customer
        setCustomerLeadList(
          res?.data?.leadList?.map((item: any) => {
            let productName = "";
            let productSubCategory = "";

            if (item?._product) {
              productName = item._product.name;
              productSubCategory = item._product.subCategory;
            } else {
              const productNameSet: Set<string> = new Set();
              const subCategorySet: Set<string> = new Set();

              item?.product_details?.forEach((prod: any) => {
                if (!prod) return;

                let displayName = prod.name;

                if (prod.product_id === 9) {
                  displayName = "Currency Notes";
                } else if (prod.product_id === 16 || prod.product_id === 36) {
                  displayName = "Forex Card";
                }

                // ✅ add inside loop
                if (displayName) productNameSet.add(displayName);
                if (prod?.subCategory) subCategorySet.add(prod.subCategory);
              });

              productName = Array.from(productNameSet).join(", ");
              productSubCategory = Array.from(subCategorySet).join(", ");
            }

            return {
              id: item?.id,
              uniqueId: item?.unique_id,
              contactPerson: item?._contacts?.[0]?.contactName,
              product: productName,
              assignedTo: item?.assignedTo !== 0 ? item?._staff?.fname : name,
              createDate: getRelativeDate(item?.created_at),
              source: item?._channel_of_interaction?.[0]?.Channel,
              opportunityContactStatus: item?.reasonToClose,
              contactNumber: item?._contacts?.[0]?.contactNumber,
              subCategory: productSubCategory,
              location: item?._staff?.city,
              createdBy: item?.createdBy !== 0 ? item?._createdBy?.fname : name,
              lead_deatils: item?._channel_of_interaction?.[0],
              referred_partner: item?._refferedBy_partner?.name,
              referred_employee: item?._refferedBy_employee?.name,
              requestQuote_Type: item?.quotation_req,
              req_book_rate: item?.req_book_rate,
              purpose_id: item?.purpose_id,
              channel_of_interaction_id: item?._channel_of_interaction?.[0]?.id,
              contacts_id: item?._contacts?.[0]?.id,
              stage_tag: item?.stage_tags,
            };
          })
        );

      })
      .catch((err) => {
        console.error("Error fetching partner details:", err);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const updateCustomerStatus = (): null | void => {
    const auth: string | null = localStorage.getItem("authToken");
    if (auth === null) return null;
    const authToken = JSON.parse(auth);
    const payload: AxiosRequestConfig<PutCustomerStatusRequestType> = {
      data: {
        customers_id: id,
        status: updatestatus,
      },
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    };

    putCustomerStatus(payload)
      .then((res) => {
        toast.success("Status Updated Successfully");
        fetchPartnerDetails();
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message || "Something went wron");
      });
  };

  const resumeRegistration = (): void | null => {
    dispatch(setResumeRegistration(true));
    localStorage.setItem("customer", id);
    navigate(`/partnerregistration`);
  };

  let customerbg = "";
  const status = customerDetails?.status;
  switch (status) {
    case "pending":
      customerbg = "bg-[#f7cb73]";
      break;
    case "active":
      customerbg = "bg-[#008000]";
      break;
    case "conditional active":
      customerbg = "bg-[#008000]";
      break;
    case "blocked":
      customerbg = "bg-[#FF0000]";
      break;
    case "archieved":
      customerbg = "bg-[#808080]";
      break;
  }

  const handleUpdateCompany = async (value: any) => {
    setLoading(true);
    const auth = localStorage.getItem("authToken");
    if (auth === null) return;
    const authToken = JSON.parse(auth);

    let payload: AxiosRequestConfig<PutUpdateCustomerDetailsReqType> = {
      headers: { Authorization: `Bearer ${authToken}` },
    };
    if (pipelineType === "retail") {
      payload.data = {
        customers_id: id as string,
        name: value?.contact_name,
        phone_number: value?.contact_number,
        email: value?.contact_email,
        address: value?.contact_address,
        notes: inputValue || "",
      };
    }

    try {
      const res = (await PutUpdateCustomerDetails(payload)) as any;
      if (res.status === 200) {
        toast.success("Customer details updated successfully");
        handleDialogOpen(false);
        await fetchPartnerDetails();
        setLoading(false);
      }
    } catch (error) {
      toast.error("Failed to update Customer details");
      setLoading(false);
    }
  };

  const handleCustomerNotesUpdated = async () => {
    const auth = localStorage.getItem("authToken");
    if (auth === null) return;
    const authToken = JSON.parse(auth);

    let payload: AxiosRequestConfig<PutUpdateCustomerDetailsReqType> = {
      headers: { Authorization: `Bearer ${authToken}` },
    };
    if (pipelineType === "retail") {
      payload.data = {
        customers_id: id as string,
        notes: inputValue || "",
      };
    }

    try {
      const res = (await PutUpdateCustomerDetails(payload)) as any;
      if (res.status === 200) {
        toast.success("Customer notes updated successfully");
        handleDialogOpen(false);
        await fetchPartnerDetails();
        setLoading(false);
        setIsEditing(false);
      }
    } catch (error) {
      toast.error("Failed to Customer notes updated");
      setLoading(false);
    }
  };

  const getDocsForDownload = async () => {
    const auth = localStorage.getItem("authToken");
    if (auth === null) return;
    const authToken = JSON.parse(auth);
    const payload: AxiosRequestConfig<GetOpportunityByIdReqType> = {
      headers: { Authorization: `Bearer ${authToken}` },
      params: {
        contacts_id: id,
      },
    };
    try {
      await downloadDoc(payload);
    } catch (error) {
      console.error("Error fetching docs:", error);
    }
  };

  const handleDialogOpen = (open: boolean) => {
    setDialogOpen(open);
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setInputValue(e.target.value);
  };

  const handleSave = () => {
    if (inputValue) {
      handleCustomerNotesUpdated();
    }
  };

  const columns: ColumnDef<OpportunityContactType>[] = [
    {
      accessorKey: "id",
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title="ID" />
      ),
      cell: ({ row }) => {
        const stageTag = stageTags?.find(
          (stage) =>
            stage.value.toLowerCase() ===
            row?.original?.stage_tag?.toLowerCase()
        );
        return (
          <div className="flex flex-col gap-1.5">
            <div className="flex flex-row gap-2.5 items-center relative group">
              {row?.original?.requestQuote_Type && (
                <div className="relative group flex items-center">
                  <div className="w-2.5 h-2.5 bg-red-500 rounded-full"></div>
                  <span className="absolute bottom-full left-0 mb-1 bg-gray-300 text-[#333] text-xs rounded-md py-1 px-2 opacity-0 group-hover:opacity-100 transition-opacity duration-200 whitespace-nowrap z-10">
                    Quotation request for ID: {row.getValue("id")}
                  </span>
                </div>
              )}
              <div className="flex flex-row justify-start gap-4">
                <p className="capitalize text-sm leading-4">
                  {row.getValue("id")}
                </p>
                {row?.original?.stage_tag && (
                  <div className="flex gap-1.5 items-center">
                    <span
                      dangerouslySetInnerHTML={{ __html: stageTag?.icon || "" }}
                      className=""
                    />
                    <h4
                      className={`${stageTag?.color} text-sm leading-4 font-semibold`}
                    >
                      {row.original?.stage_tag}
                    </h4>
                  </div>
                )}
              </div>
            </div>
            <div className="capitalize font-normal text-sm text-[#666666]">
              <TooltipProvider>
                <Tooltip>
                  <TooltipTrigger
                    className="flex cursor-pointer items-center w-full md:w-auto"
                    asChild
                  >
                    <div className="flex items-center space-x-1">
                      <p className="text-sm md:text-base leading-[22px] md:leading-[25px] text-black-label">
                        {row.original.createDate}
                      </p>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-4 w-4 text-gray-500"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                      >
                        <path
                          fillRule="evenodd"
                          d="M18 10c0 4.418-3.582 8-8 8s-8-3.582-8-8 3.582-8 8-8 8 3.582 8 8zm-8-3a1 1 0 100 2 1 1 0 000-2zm-1 4a1 1 0 012 0v2a1 1 0 01-2 0v-2z"
                          clipRule="evenodd"
                        />
                      </svg>
                    </div>
                  </TooltipTrigger>
                  <TooltipContent
                    side="bottom"
                    className="bg-black-900 text-white-A700 max-w-[300px] whitespace-normal break-words border-0"
                  >
                    <p className="text-sm md:text-base leading-[22px] md:leading-[25px]">
                      {row?.original.createdBy}
                    </p>
                  </TooltipContent>
                </Tooltip>
              </TooltipProvider>
            </div>
          </div>
        );
      },
      enableHiding: false,
      filterFn: (row, id, value) => {
        const rowValue = String(row.getValue(id));
        const searchValue = String(value);
        return rowValue.includes(searchValue);
      },
    },
    {
      accessorKey: "product",
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title="Product" />
      ),
      cell: ({ row }) => {
        return (
          <div className="flex flex-col gap-1.5">
            <p className="capitalize">{row.getValue("product")}</p>
          <p className="capitalize font-normal text-sm text-[#666666]">
            {row?.original?.productSubCategory}
          </p>
          </div>
        );
      },
      filterFn: (row, id, value) => {
        return String(row.getValue(id))
          .toLowerCase()
          .includes(String(value).toLowerCase());
      },
      enableSorting: false,
    },
    {
      accessorKey: "assignedTo",
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title="Assigned To" />
      ),
      cell: ({ row }) => {
        return (
          <div className="flex flex-col gap-1.5">
            <p className="capitalize">{row.getValue("assignedTo")}</p>
            <p className="capitalize font-normal text-sm text-[#666666]">
              {row?.original?.location}
            </p>
          </div>
        );
      },
      filterFn: (row, id, value) => {
        return String(row.getValue(id))
          .toLowerCase()
          .includes(String(value).toLowerCase());
      },
      enableSorting: false,
    },
    {
      id: "source",
      accessorKey: "source",
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title="Channel" />
      ),
      cell: ({ row }) => {
        const newSource = (channel_options as ChannelOptions)?.[
          (row?.original?.lead_deatils?.Type as string)?.toLowerCase()
        ]?.find(
          (item) =>
            item.value?.toLowerCase() ===
            (row.getValue("source") as string)
              ?.toLowerCase()
              .split(" ")
              .join("")
        );

        return newSource?.value ? (
          <div className="grid items-start w-fill  gap-1">
            <div className="flex items-start flex-col gap-3  w-full">
              <div className="h-full w-full flex gap-5">
                <p className="capitalize whitespace-nowrap ">
                  {newSource?.label}
                </p>
                <Img
                  className="text-right h-5 w-5"
                  src={newSource?.icon}
                  alt="icon"
                />
              </div>
              <p className="capitalize font-normal text-sm text-[#666666]">
                {["outletID", "partnerOffice"].includes(
                  row?.original?.lead_deatils?.source
                )
                  ? ""
                  : row?.original?.lead_deatils?.source === "linkdin"
                  ? "LinkedIn"
                  : row?.original?.lead_deatils?.source}
              </p>
            </div>
          </div>
        ) : (
          <p className="capitalize">{row.getValue("source")}</p>
        );
      },
      filterFn: (row, id, value) => {
        return String(row.getValue(id))
          .toLowerCase()
          .includes(String(value).toLowerCase());
      },
      enableSorting: false,
    },
    {
      accessorKey: "opportunityContactStatus",
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title="Status" />
      ),
      cell: ({ row }) => {
        const values = close_reason_options.find(
          (item) =>
            item.value === (row.getValue("opportunityContactStatus") as string)
        );
        if (!values) {
          return (
            <p
              style={{ color: "#23AB28", backgroundColor: "#E1FFE2" }}
              className="py-[3px] px-2 text-center rounded-md"
            >
              Open
            </p>
          );
        }
        return (
          <p
            style={{
              color: values?.textColor,
              backgroundColor: values?.bgColor,
            }}
            className="py-[3px] px-2 text-center rounded-md"
          >
            {values.label}
          </p>
        );
      },
      filterFn: (row, id, value) => {
        return value.includes(row.getValue(id));
      },
      enableSorting: false,
    },
  ];

  const filteredColumns = checkLevel(LEVEL_2)
    ? columns.filter((col) => col.id !== "source")
    : columns;

  const { label, href } = buttonInfo();

  React.useEffect(() => {
    fetchPartnerDetails();
  }, []);

  // for Lead have get details
  const getOpportunityList = async () => {
    setLoading(true);
    const auth = localStorage.getItem("authToken");
    if (!auth) {
      setLoading(false);
      return;
    }
    const authToken = JSON.parse(auth);
    const name = localStorage.getItem("owner_name")?.toString();
    let payload: AxiosRequestConfig<GetOpportunityByCompanyReqType> = {
      headers: { Authorization: `Bearer ${authToken}` },
      params: { contactID: customerDetails?.id },
    };

    try {
      const response = (await getOpportunityByCompany(payload)) as any;

      if (!response?.data || response?.data?.length === 0) {
        setLoading(false);
        return;
      }
      setOpportunityList(
       response?.data?.map((item: any) => {
           let productName = "";
           let productSubCategory = "";

           if (item?._product) {
             productName = item?._product.name;
             productSubCategory = item?._product.subCategory;
           } else {
             const productNameSet: Set<string> = new Set();
             const subCategorySet: Set<string> = new Set();

             item?.product_details?.forEach((prod: any) => {
               if (!prod) return;

               let displayName = prod.name;

               if (prod.product_id === 9) {
                 displayName = "Currency Notes";
               } else if (prod.product_id === 16 || prod.product_id === 36) {
                 displayName = "Forex Card";
               }

               if (displayName) productNameSet.add(displayName);
               if (prod?.subCategory) subCategorySet.add(prod.subCategory);
             });

             productName = Array.from(productNameSet).join(", ");
             productSubCategory = Array.from(subCategorySet).join(", ");
           }
           return {
          id: item?.id,
          uniqueId: item?.unique_id,
          contactPerson: item?._contacts?.[0]?.contactName,
          product:productName,
          assignedTo: item?.assignedTo !== 0 ? item?._staff?.fname : name,
          createDate: getRelativeDate(item?.created_at),
          source: item?._channel_of_interaction?.[0]?.Channel,
          opportunityContactStatus: item?.reasonToClose,
          contactNumber: item?._contacts?.[0]?.contactNumber,
          subCategory: productSubCategory,
          location: item?._staff?.city,
          createdBy: item?.createdBy !== 0 ? item?._createdBy?.fname : name,
          lead_deatils: item?._channel_of_interaction?.[0],
          referred_partner: item?._refferedBy_partner?.name,
          referred_employee: item?._refferedBy_employee?.name,
          requestQuote_Type: item?.quotation_req,
          req_book_rate: item?.req_book_rate,
          purpose_id: item?.purpose_id,
          channel_of_interaction_id: item?._channel_of_interaction?.[0]?.id,
          contacts_id: item?._contacts?.[0]?.id,
          stage_tag: item?.stage_tags,
           };
        })
      );
    } catch (error) {
      console.error("Error fetching opportunities:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!customerDetails?.id || customerDetails?.id === 0) {
      return;
    }
    getOpportunityList();
  }, [customerDetails?.id]);

  // for Order Tab
  const OrderColumns: ColumnDef<OpportunityContactType>[] = [
    {
      accessorKey: "id",
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title="Order ID" />
      ),
      enableHiding: false,
      filterFn: (row, id, value) => {
        const rowValue = String(row.getValue(id));
        const searchValue = String(value);
        return rowValue.includes(searchValue);
      },
    },

    {
      accessorKey: "product",
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title="Product" />
      ),
      cell: ({ row }) => {
        return (
          <div className="flex flex-col gap-1.5">
            <p className="capitalize">{row.getValue("product")}</p>
            <p className="capitalize font-normal text-sm text-[#666666]">
              {row?.original?.subCategory}
            </p>
          </div>
        );
      },
      filterFn: (row, id, value) => {
        return String(row.getValue(id))
          .toLowerCase()
          .includes(String(value).toLowerCase());
      },
      enableSorting: false,
    },
    {
      accessorKey: "assignedTo",
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title="Assigned To" />
      ),
      cell: ({ row }) => {
        return (
          <div className="flex flex-col gap-1.5">
            <p className="capitalize">{row.getValue("assignedTo")}</p>
            <p className="capitalize font-normal text-sm text-[#666666]">
              {row?.original?.location}
            </p>
          </div>
        );
      },
      filterFn: (row, id, value) => {
        return String(row.getValue(id))
          .toLowerCase()
          .includes(String(value).toLowerCase());
      },
      enableSorting: false,
    },
    {
      accessorKey: "status",
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title="Status" />
      ),
      cell: ({ row }) => {
        return (
          <p className="py-[3px] px-2 text-center rounded-md">
            {row.getValue("status")}
          </p>
        );
      },
      filterFn: (row, id, value) => {
        return value.includes(row.getValue(id));
      },
      enableSorting: false,
    },
  ];

  const handleRowClick = (row: OpportunityContactType) => {
    setSelectedRowData(row);
    setIsRowDetailsOpen(true);
  };

  // handle Get Quote
  const handleGetQuoteLead = (
    e: React.FormEvent<HTMLFormElement>
  ): void | null => {
    e.preventDefault();
    dispatch(setIsReferralMade(true));
    navigate("/lead/getquote", {
      state: {
        id: customerDetails?.id,
        contact_name: customerDetails?.full_name,
        contact_number: customerDetails?.phone_number,
        contact_email: customerDetails?.email,
        currentpath: "customerdetails",
        customerID: customerDetails?.id,
      },
    });
  };

  // New Referral Lead flow
  const handleNewReferralLead = (e: React.FormEvent<HTMLFormElement>): void => {
    e.preventDefault();
    dispatch(setIsReferralMade(true));
    navigate("/lead/retails/createlead", {
      state: {
        id: customerDetails?.id,
        contact_name: customerDetails?.full_name,
        contact_number: customerDetails?.phone_number,
        contact_email: customerDetails?.email,
        currentpath: "customerdetails",
        customerID: customerDetails?.id,
      },
    });
  };

  const handleCreateLead = (
    e: React.FormEvent<HTMLFormElement>
  ): void | null => {
    e.preventDefault();
    dispatch(setIsReferralMade(false));
    navigate("/lead/retails/createlead", {
      state: {
        id: customerDetails?.id,
        contact_name: customerDetails?.full_name,
        contact_number: customerDetails?.phone_number,
        contact_email: customerDetails?.email,
        currentpath: "customerdetails",
        customerID: customerDetails?.id,
      },
    });
  };

  const mergedList = [
    ...(Array.isArray(customerLeadList)
      ? customerLeadList
      : [customerLeadList]),
    ...(Array.isArray(opportunityList) ? opportunityList : [opportunityList]),
  ];
  const uniqueByIdMap = new Map();
  mergedList.forEach((item) => {
    if (item?.id) {
      uniqueByIdMap.set(item.id, item);
    }
  });
  const sortedUniqueList = Array.from(uniqueByIdMap.values()).sort(
    (a, b) =>
      new Date(b.createDate).getTime() - new Date(a.createDate).getTime()
  );

  // console.log("Sorted Unique List", sortedUniqueList, customerLeadList, opportunityList);
  const isMobile = useIsMobile();

  return (
    <>
      {loading && <Spinner />}
      {isMobile ? (
        <MobileCustomerDetails />
      ) : (
        <>
          {showimg && (
            <div
              style={{ backgroundColor: "rgba(0, 0, 0, .6)" }}
              className="fixed top-0 left-0 z-[10] h-screen w-[100vw] flex justify-center items-center"
            >
              {" "}
              <Img
                src={imgsrc}
                className="h-[300px] w-[400px]"
                alt="Loading...."
              />
              <div
                className="relative top-[-150px] left-[10px]"
                onClick={() => setShowimg(!showimg)}
              >
                <AiOutlineCloseCircle className="text-[30px] cursor-pointer" />
              </div>
            </div>
          )}

          <div className="flex h-full sm:py-2 sm:px-0 w-full flex-col font-inter font-thin px-2">
            <NavbarWithActions
              header={
                <div className="bg-white-A700 text-[#797D8C] flex md:flex-col flex-row font-inter gap-2.5 items-center rounded-[10px] w-full">
                  <div className="flex flex-row gap-4 text-left">
                    <Text className="text-[#333333] text-[18px] font-semibold">
                      {customerDetails?.full_name &&
                        Capitalize(customerDetails?.full_name)}
                    </Text>
                    {customerDetails?.kyc_status === "active" && (
                      <CircleCheck color="#3FB73D" />
                    )}
                  </div>

                  <Text className="font-inter text-gray-600_04 text-sm w-auto bg-[#F4F4F4] p-2 rounded-[5px]">
                    <span className="text-gray-600_04 text-left font-normal">
                      Customer ID:{" "}
                    </span>
                    <span className="text-black-900 text-left font-normal">
                      {customerDetails?.id}{" "}
                    </span>
                  </Text>
                  <Text className="text-gray-600_04 text-left font-normal">
                    Customer Since{" "}
                    {new Date(customerDetails?.created_at)
                      .toLocaleDateString("en-GB", {
                        day: "2-digit",
                        month: "short",
                        year: "numeric",
                      })
                      .replace(/ /g, "-")}
                  </Text>
                </div>
              }
            />

            <div className="bg-white-A700 mt-5 text-[#797D8C] flex flex-col font-inter gap-2.5 items-start md:px-10 sm:px-5 px-[20px] py-6 rounded-[10px] w-full">
              <div className="flex flex-wrap gap-4 md:flex-nowrap">
                {Boolean(customerDetails?.partnerDetail?.id) &&
                  !checkLevel(LEVEL_2) && (
                    <div className="flex flex-row items-center gap-2">
                      <Text className="p-2 py-1 bg-[#E1EBFC] text-[#000] rounded-[10px]">
                        P
                      </Text>
                      <a
                        onClick={(e) => {
                          e.preventDefault();
                          const id = customerDetails?.partnerDetail?.id;
                          const status = customerDetails?.partnerDetail?.status;
                          if (status === "active") {
                            navigate(`/partnerDetails/${id}`);
                          } else {
                            navigate(`/leads/partner/${id}`);
                          }
                        }}
                        className="text-[#165FE3] text-[14px] font-semibold underline flex items-center gap-1 cursor-pointer"
                      >
                        {customerDetails?.partnerDetail.name || "N/A"}
                        <ArrowUpRight className="w-4 h-4 transform text-[#165FE3]" />
                      </a>
                    </div>
                  )}

                {Boolean(customerDetails?.companyDetail?.id) &&
                  !checkLevel(LEVEL_2) && (
                    <div className="flex flex-row items-center gap-2">
                      <Text className="p-2 py-1 bg-[#E1EBFC] text-[#000] rounded-[10px]">
                        C
                      </Text>
                      <a
                        href={`/leads/corporate/${customerDetails?.companyDetail?.id}`}
                        className="text-[#165FE3] text-[14px] font-semibold underline flex items-center gap-1"
                      >
                        {customerDetails?.companyDetail?.entity_name || "N/A"}
                        <ArrowUpRight className="w-4 h-4 transform text-[#165FE3]" />
                      </a>
                    </div>
                  )}
              </div>
              <div className="flex gap-4 w-full justify-between sm:flex-col">
                <div className="bg-[#fafafa] p-4 rounded-xl w-[40%] md:w-full  relative">
                  <div className="grid relative md:grid-cols-1 sm:grid-cols-1 w-full gap-5">
                    {!checkLevel(LEVEL_2) && (
                      <div className="flex float-right absolute -top-3 -right-4 gap-2">
                        <AlertDialog open={dialogOpen}>
                          <AlertDialogTrigger
                            onClick={() => handleDialogOpen(!dialogOpen)}
                          >
                            <div className=" cursor-pointer ">
                              <svg
                                width="20"
                                height="21"
                                viewBox="0 0 20 21"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <g clipPath="url(#clip0_1689_36824)">
                                  <path
                                    d="M3.83594 4.82812H3.0026C2.56058 4.82813 2.13665 5.00372 1.82409 5.31628C1.51153 5.62884 1.33594 6.05276 1.33594 6.49479V13.9948C1.33594 14.4368 1.51153 14.8607 1.82409 15.1733C2.13665 15.4859 2.56058 15.6615 3.0026 15.6615H10.5026C10.9446 15.6615 11.3686 15.4859 11.6811 15.1733C11.9937 14.8607 12.1693 14.4368 12.1693 13.9948V13.1615"
                                    stroke="#165FE3"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                  <path
                                    d="M11.3333 3.16676L13.8333 5.66676M14.9875 4.48759C15.3157 4.15938 15.5001 3.71424 15.5001 3.25009C15.5001 2.78594 15.3157 2.34079 14.9875 2.01259C14.6593 1.68438 14.2142 1.5 13.75 1.5C13.2858 1.5 12.8407 1.68438 12.5125 2.01259L5.5 9.00009V11.5001H8L14.9875 4.48759Z"
                                    stroke="#165FE3"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                </g>
                                <defs>
                                  <clipPath id="clip0_1689_36824">
                                    <rect
                                      width="20"
                                      height="20"
                                      fill="white"
                                      transform="translate(0 0.5)"
                                    />
                                  </clipPath>
                                </defs>
                              </svg>
                            </div>
                          </AlertDialogTrigger>
                          <AlertDialogPortal>
                            <AlertDialogOverlay className=" bg-black-900 bg-opacity-60 animate-overlayShow fixed inset-0" />
                            <AlertDialogContent className="bg-white-A700 rounded-lg p-0 max-w-2xl w-full animate-contentShow sm:max-w-[90%]">
                              <AlertDialogHeader className="flex text-left border-b  rounded-t py-5 px-10 ">
                                <AlertDialogTitle className="font-bold capitalize p-0 text-lg text-black-label">
                                  Edit {pipelineType} contact details
                                </AlertDialogTitle>
                                <AlertDialogDescription className="font-medium p-0 text-sm  text-[#7E7E7E] ">
                                  Fill the required details
                                </AlertDialogDescription>
                              </AlertDialogHeader>
                              <FormProvider {...methods}>
                                <div className="h-[500px] overflow-auto w-full">
                                  <EditForm customerDetails={customerDetails} />
                                </div>
                              </FormProvider>
                              <AlertDialogFooter className="flex justify-start items-center gap-2.5 py-5 px-10 flex-row rounded-b-lg bg-gray-button-gray-lite">
                                <AlertDialogCancel
                                  className=" m-0 rounded-lg border-blue-700 border py-[11px] px-4 text-blue-700"
                                  asChild
                                >
                                  <button
                                    onClick={() => {
                                      methods.reset();
                                      methods.clearErrors();
                                      setDialogOpen(false);
                                    }}
                                  >
                                    Cancel
                                  </button>
                                </AlertDialogCancel>
                                <AlertDialogAction
                                  className="rounded-lg border-blue-700 py-[11px] px-4 bg-blue-700 border text-white-A700"
                                  asChild
                                >
                                  <button
                                    className=""
                                    disabled={!methods.formState.isDirty}
                                    onClick={methods.handleSubmit(
                                      handleUpdateCompany
                                    )}
                                  >
                                    Submit
                                  </button>
                                </AlertDialogAction>
                              </AlertDialogFooter>
                            </AlertDialogContent>
                          </AlertDialogPortal>
                        </AlertDialog>
                      </div>
                    )}
                    {pipelineType === "retail" && (
                      <>
                        <div className="flex items-center gap-x-2.5 gap-y-1">
                          <div className="">
                            <svg
                              width="20"
                              height="21"
                              viewBox="0 0 20 21"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M4.03832 13.8267L4.03824 13.8266C2.4108 11.8712 1.31349 10.0388 0.585923 8.06396C0.111832 6.78722 -0.0725525 5.72711 0.00693179 4.72728L0.0069486 4.72707C0.0742514 3.92365 0.398545 3.22884 0.970445 2.65694L2.52038 1.107L2.52123 1.10615L2.52124 1.10616C2.97237 0.676114 3.48987 0.45 4.03108 0.45C4.57615 0.45 5.08956 0.675888 5.52435 1.10202C5.80703 1.36394 6.09357 1.65466 6.367 1.93637L6.37833 1.94804C6.51528 2.08901 6.64833 2.22598 6.78919 2.36684L8.024 3.60166C8.02404 3.60169 8.02407 3.60172 8.02411 3.60176C8.48331 4.05679 8.72675 4.58699 8.72675 5.12909C8.72675 5.67141 8.47898 6.20155 8.02417 6.65637C7.89564 6.78489 7.76746 6.91307 7.64347 7.04119L7.64331 7.04137C7.29903 7.39375 6.94201 7.75494 6.56121 8.101C6.83589 8.72675 7.22748 9.34413 7.80816 10.0791C8.97807 11.5136 10.2008 12.6286 11.5465 13.4831L11.5465 13.4831C11.6809 13.5686 11.8321 13.6463 11.9979 13.7292L11.9984 13.7295C12.1201 13.7903 12.25 13.8552 12.3774 13.9271L13.8341 12.4704C14.2769 12.0277 14.7988 11.7886 15.3448 11.7886C15.8907 11.7886 16.4087 12.0276 16.8393 12.4749C16.8394 12.475 16.8395 12.4752 16.8396 12.4753L19.3296 14.9653C19.783 15.4187 20.0125 15.9458 20.0135 16.4795C20.0146 17.013 19.7874 17.5472 19.3386 18.0149C19.1473 18.2146 18.9478 18.4099 18.7528 18.5966C18.7528 18.5966 18.7528 18.5966 18.7528 18.5966L4.03832 13.8267ZM4.03832 13.8267C6.01544 16.1901 8.39569 18.0512 11.1125 19.368L11.1129 19.3682M4.03832 13.8267L11.1129 19.3682M11.1129 19.3682C12.1459 19.8578 13.5331 20.4415 15.0805 20.5416L15.0815 20.5417M11.1129 19.3682L15.0815 20.5417M15.0815 20.5417L15.0934 20.5422M15.0815 20.5417L15.0934 20.5422M4.74134 1.91097L4.74138 1.91093C4.51188 1.6774 4.26707 1.56533 4.03108 1.56533C3.79038 1.56533 3.53711 1.67791 3.30359 1.90326L1.76225 3.4446C1.37284 3.834 1.16652 4.28297 1.11779 4.82251C1.0523 5.64574 1.21172 6.55392 1.63696 7.68926L1.63702 7.68942C2.3226 9.53968 3.35954 11.2671 4.90243 13.1244C6.77527 15.3652 9.03235 17.1303 11.6035 18.3745C12.5515 18.8257 13.8082 19.3525 15.1574 19.4389C15.2279 19.4431 15.301 19.4471 15.3697 19.4471C16.0896 19.4471 16.6436 19.2123 17.11 18.7098C17.3701 18.3986 17.656 18.121 17.9308 17.8543C17.9468 17.8388 17.9629 17.8232 17.9788 17.8077L17.9791 17.8074C18.1737 17.6211 18.3552 17.4437 18.5283 17.2583L18.5288 17.2577C18.7761 17.0003 18.8952 16.7457 18.8972 16.4999C18.8991 16.2546 18.7843 16.0077 18.5419 15.7654L16.043 13.2706L16.0417 13.2692L16.0417 13.2692C15.8836 13.099 15.6391 12.9163 15.3448 12.9163C15.1052 12.9163 14.8561 13.0362 14.6218 13.2705L13.0718 14.8205C13.0004 14.8919 12.7722 15.1169 12.419 15.1169C12.2776 15.1169 12.1373 15.0815 11.9944 15.0079C11.9943 15.0079 11.9942 15.0078 11.9941 15.0078L12.017 14.9633C12.0087 14.9592 12.0015 14.955 11.9942 14.9509C11.9869 14.9467 11.9797 14.9426 11.9714 14.9385L4.74134 1.91097ZM4.74134 1.91097L4.74308 1.91258C4.98288 2.13448 5.21025 2.36567 5.45043 2.60989C5.48723 2.64732 5.52434 2.68505 5.56184 2.72309L4.74134 1.91097ZM15.0934 20.5422C15.1843 20.5461 15.2729 20.55 15.3655 20.55M15.0934 20.5422L15.3655 20.55M15.3655 20.55C16.4105 20.55 17.2526 20.1884 17.9378 19.4448M15.3655 20.55L17.9378 19.4448M17.9378 19.4448C17.9413 19.4413 17.9518 19.4309 17.9597 19.4178L17.9378 19.4448Z"
                                fill="#999999"
                                stroke="#999999"
                                strokeWidth="0.1"
                              />
                            </svg>
                          </div>
                          <p className="text-sm md:text-base leading-[22px] md:leading-[25px] text-black-label">
                            {customerDetails?.phone_number || (
                              <span className="text-gray-400">
                                Not available
                              </span>
                            )}
                          </p>
                        </div>

                        <div className="flex flex-wrap items-center gap-x-2.5 gap-y-1">
                          <div className="">
                            <svg
                              width="20"
                              height="17"
                              viewBox="0 0 20 17"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M1.10812 3.83305C0.947499 3.72606 0.815788 3.58106 0.72469 3.41092C0.633593 3.24078 0.58593 3.05077 0.585938 2.85778V2.8568C0.585938 2.16395 1.14765 1.60227 1.84054 1.60227H18.1594C18.8522 1.60227 19.4139 2.16395 19.4139 2.8568V2.85778C19.4139 3.24969 19.2181 3.61559 18.8918 3.83305C17.2992 4.89496 12.5006 8.09382 10.6963 9.29694C10.4901 9.43444 10.2478 9.50781 9.99995 9.50781C9.75212 9.50781 9.50984 9.43444 9.30365 9.29694C7.49928 8.09382 2.70066 4.89496 1.10812 3.83305Z"
                                stroke="#999999"
                                strokeWidth="1.3"
                                strokeMiterlimit="10"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M0.585938 2.85426V14.1511C0.585894 14.3159 0.618355 14.4791 0.681462 14.6314C0.744568 14.7837 0.837082 14.922 0.95371 15.0385C1.07019 15.1551 1.20853 15.2476 1.3608 15.3107C1.51307 15.3738 1.6763 15.4063 1.84113 15.4062H18.1587C18.3236 15.4063 18.4868 15.3738 18.6391 15.3107C18.7913 15.2476 18.9297 15.1551 19.0462 15.0385C19.1628 14.922 19.2553 14.7837 19.3184 14.6314C19.3815 14.4791 19.414 14.3159 19.4139 14.1511V2.85426"
                                stroke="#999999"
                                strokeWidth="1.3"
                                strokeMiterlimit="10"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          </div>
                          <p className="text-sm md:text-base leading-[22px] md:leading-[25px] text-black-label">
                            {customerDetails?.email || (
                              <span className="text-gray-400">
                                Not available
                              </span>
                            )}
                          </p>
                        </div>

                        <div className="flex w-full items-center gap-x-2.5 gap-y-1">
                          <div className="">
                            <svg
                              width="16"
                              height="21"
                              viewBox="0 0 16 21"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M8 0.5C4.12297 0.5 0.96875 3.65422 0.96875 7.53125C0.96875 8.84117 1.3316 10.1195 2.01832 11.2286L7.59977 20.223C7.65233 20.3077 7.72564 20.3776 7.81276 20.4261C7.89988 20.4746 7.99792 20.5 8.09762 20.5H8.10227C8.20274 20.4992 8.30133 20.4726 8.38855 20.4227C8.47577 20.3728 8.54869 20.3014 8.60031 20.2152L14.0395 11.1336C14.6883 10.048 15.0312 8.80231 15.0312 7.53125C15.0312 3.65422 11.877 0.5 8 0.5ZM13.0338 10.532L8.08875 18.7885L3.01434 10.6112C2.44273 9.68805 2.13281 8.62305 2.13281 7.53125C2.13281 4.30039 4.76914 1.66406 8 1.66406C11.2309 1.66406 13.8633 4.30039 13.8633 7.53125C13.8633 8.59066 13.5738 9.62844 13.0338 10.532Z"
                                fill="#999999"
                              />
                              <path
                                d="M8 4.01562C6.06148 4.01562 4.48438 5.59273 4.48438 7.53125C4.48438 9.45738 6.03582 11.0469 8 11.0469C9.9884 11.0469 11.5156 9.43621 11.5156 7.53125C11.5156 5.59273 9.93852 4.01562 8 4.01562ZM8 9.88281C6.7009 9.88281 5.64844 8.82684 5.64844 7.53125C5.64844 6.23891 6.70766 5.17969 8 5.17969C9.29234 5.17969 10.3477 6.23891 10.3477 7.53125C10.3477 8.80793 9.31969 9.88281 8 9.88281Z"
                                fill="#999999"
                              />
                            </svg>
                          </div>
                          <TooltipProvider>
                            <Tooltip>
                              <TooltipTrigger
                                className="flex cursor-pointer items-end w-full md:w-auto"
                                asChild
                              >
                                <p className="text-sm md:text-base leading-[22px] md:leading-[25px] text-black-label">
                                  {customerDetails?.address_line_1 ? (
                                    `${customerDetails?.address_line_1
                                      ?.charAt(0)
                                      ?.toUpperCase()}${customerDetails?.address_line_1?.slice(
                                      1,
                                      30
                                    )}`
                                  ) : (
                                    <span className="text-gray-400">
                                      Not available
                                    </span>
                                  )}
                                </p>
                              </TooltipTrigger>
                              {/* <TooltipContent
                            side="bottom"
                            className="bg-black-900 text-white-A700 max-w-[200px] whitespace-normal break-words border-0"
                          >
                            <p className="text-sm md:text-base leading-[22px] md:leading-[25px]">
                              {companyData?.contactAddress?.at(-1)}
                            </p>
                          </TooltipContent> */}
                            </Tooltip>
                          </TooltipProvider>
                        </div>
                      </>
                    )}
                  </div>
                </div>
                {/* Right div */}
                <div className="bg-[#fafafa] p-5 flex sm:flex-row gap-3 md:w-full sm: w-full rounded-xl relative">
                  <TooltipProvider>
                    <Tooltip>
                      <TooltipTrigger asChild>
                        {isEditing ? (
                          <div className="relative flex  flex-col gap-2 items-start">
                            <textarea
                              value={inputValue}
                              onChange={handleInputChange}
                              className="border rounded p-2 sm:w-full w-[400px] resize-none focus:outline-none overflow-auto "
                              placeholder="Enter your notes here"
                              rows={4}
                              style={{ minHeight: "100px", maxHeight: "200px" }}
                            />
                            <div className="flex justify-end gap-2">
                              <button
                                onClick={handleSave}
                                className="text-white-A700 cursor-pointer bg-blue-700 text-sm rounded-lg py-1.5 px-3 hover:bg-blue-700"
                              >
                                Save
                              </button>
                              <button
                                onClick={() => setIsEditing(false)}
                                className="text-gray-600 bg-gray-300 cursor-pointer text-sm rounded-lg py-1.5 px-3 hover:bg-gray-400"
                              >
                                Cancel
                              </button>
                            </div>
                          </div>
                        ) : (
                          <div className="whitespace-nowrap overflow-hidden text-ellipsis max-w-[400px] h-[100px]">
                            {customerDetails?.notes ? (
                              <div className="flex flex-col gap-2">
                                <div className="flex flex-row gap-2">
                                  <img
                                    src="/images/intialNotes.svg"
                                    width={15}
                                    height={15}
                                  />
                                  <TooltipProvider>
                                    <Tooltip>
                                      {!checkLevel(LEVEL_2) && (
                                        <TooltipTrigger
                                          className="flex cursor-pointer items-center w-full md:w-auto"
                                          asChild
                                        >
                                          <div className="flex items-center space-x-1">
                                            <p className="text-sm md:text-base leading-[22px] md:leading-[25px] text-black-label">
                                              Internal notes
                                            </p>
                                            <svg
                                              xmlns="http://www.w3.org/2000/svg"
                                              className="h-4 w-4 text-gray-500"
                                              viewBox="0 0 20 20"
                                              fill="currentColor"
                                            >
                                              <path
                                                fillRule="evenodd"
                                                d="M18 10c0 4.418-3.582 8-8 8s-8-3.582-8-8 3.582-8 8-8 8 3.582 8 8zm-8-3a1 1 0 100 2 1 1 0 000-2zm-1 4a1 1 0 012 0v2a1 1 0 01-2 0v-2z"
                                                clipRule="evenodd"
                                              />
                                            </svg>
                                          </div>
                                        </TooltipTrigger>
                                      )}
                                      <TooltipContent
                                        side="bottom"
                                        className="bg-black-900 text-white-A700 max-w-[200px] whitespace-normal break-words border-0"
                                      >
                                        <p className="text-sm md:text-base leading-[22px] md:leading-[25px]">
                                          Visible to the partner
                                        </p>
                                      </TooltipContent>
                                    </Tooltip>
                                  </TooltipProvider>
                                  <p className="font-normal text-xs leading-[18px] text-[#999999]">
                                    {customerDetails?.contactDetails
                                      ?.updated_at && (
                                      <>
                                        edited on{" "}
                                        {formatUnixTimestamp(
                                          customerDetails?.contactDetails
                                            ?.updated_at
                                        )}{" "}
                                        by{" "}
                                        {
                                          customerDetails?.contactDetails
                                            ?.updatedBy?.fname
                                        }
                                      </>
                                    )}
                                  </p>
                                </div>
                                <p className="whitespace-normal break-words h-full overflow-hidden overflow-ellipsis">
                                  {customerDetails?.notes}
                                </p>
                              </div>
                            ) : (
                              <p className="whitespace-normal break-words h-full overflow-hidden overflow-ellipsis">
                                No notes available
                              </p>
                            )}
                          </div>
                        )}
                      </TooltipTrigger>
                      {/* <TooltipContent
                    side="bottom"
                    className="bg-black-900 text-white-A700 max-w-xs whitespace-normal break-words border-0"
                  >
                    <p className="whitespace-normal max-w-xs break-words">
                      {companyData?.notes.length >0 && companyData.notes}
                    </p>
                  </TooltipContent> */}
                    </Tooltip>

                    {/* Right div - Edit button */}
                    <div className="flex ml-auto cursor-pointer">
                      {!isEditing && !checkLevel(LEVEL_2) && (
                        <svg
                          onClick={handleEditClick}
                          width="20"
                          height="21"
                          viewBox="0 0 20 21"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          className="ml-2 cursor-pointer"
                        >
                          <g clipPath="url(#clip0_1689_36824)">
                            <path
                              d="M3.83594 4.82812H3.0026C2.56058 4.82813 2.13665 5.00372 1.82409 5.31628C1.51153 5.62884 1.33594 6.05276 1.33594 6.49479V13.9948C1.33594 14.4368 1.51153 14.8607 1.82409 15.1733C2.13665 15.4859 2.56058 15.6615 3.0026 15.6615H10.5026C10.9446 15.6615 11.3686 15.4859 11.6811 15.1733C11.9937 14.8607 12.1693 14.4368 12.1693 13.9948V13.1615"
                              stroke="#165FE3"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                            <path
                              d="M11.3333 3.16676L13.8333 5.66676M14.9875 4.48759C15.3157 4.15938 15.5001 3.71424 15.5001 3.25009C15.5001 2.78594 15.3157 2.34079 14.9875 2.01259C14.6593 1.68438 14.2142 1.5 13.75 1.5C13.2858 1.5 12.8407 1.68438 12.5125 2.01259L5.5 9.00009V11.5001H8L14.9875 4.48759Z"
                              stroke="#165FE3"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_1689_36824">
                              <rect
                                width="20"
                                height="20"
                                fill="white"
                                transform="translate(0 0.5)"
                              />
                            </clipPath>
                          </defs>
                        </svg>
                      )}
                    </div>
                  </TooltipProvider>
                </div>

                {/* button div */}
                <div className="flex flex-col gap-4 space-y-4 w-[20%] md:w-full	sm:w-full">
                  <div
                    className="w-full rounded-lg"
                    style={{
                      backgroundColor: customer_status_options.find(
                        (val) => val.value === customerDetails?.status
                      )?.bgColor,
                    }}
                  >
                    <SelectBox
                      className={`border text-[${"red"}] border-gray-200_01 border-solid font-medium p-2 px-8 w-full rounded-lg text-[13px] text-blue_gray-700 text-left pl-[20px]`}
                      placeholderClassName="text-blue_gray-700 text-[12px]"
                      placeholder="Select Status"
                      isMulti={false}
                      value={customerDetails?.status}
                      onChange={(e) => {
                        setUpdatestatus(e);
                      }}
                      isDisabled={checkLevel(LEVEL_2)}
                      indicator={
                        <>
                          <div
                            className={`${customerbg} absolute top-[40%] left-[-10px] h-1.5 rounded-[50%] w-1.5`}
                          ></div>
                          {customerDetails?.status !== "active" && (
                            <svg
                              width="22"
                              height="23"
                              viewBox="0 0 22 23"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <image
                                href="/images/img_arrowdown.svg"
                                x="0"
                                y="0"
                                width="22"
                                height="23"
                              />
                            </svg>
                          )}
                        </>
                      }
                      options={customer_status_options}
                      name="status"
                    />
                  </div>
                  {/* <button
                      onClick={() => {
                        dispatch(setPhone(companyData?.contactNumber));
                        dispatch(setEmail(companyData?.contactEmail));
                        dispatch(setContactId(id as string));
                        navigate("/customerregistration", {
                          state: {
                            contact_name: companyData?.contactName,
                            contact_number: companyData?.contactNumber,
                            contact_email: companyData?.contactEmail,
                            currentpath: "contactDetails",
                            contactID: companyData?.id,
                            pathName: "ContactPage",
                          },
                        });
                      }}
                      className="flex items-center gap-2 whitespace-nowrap rounded-md border border-blue-700 text-blue-700 px-4 py-2"
                    >
                      <FaFingerprint size={22} />
                      Start KYC
                    </button> */}
                  <DropdownMenu>
                    <DropdownMenuTrigger className="text-[#333333] rounded-lg whitespace-nowrap font-inter text-sm font-medium leading-5 text-center border border-[#165FE3] p-2">
                      More Options
                    </DropdownMenuTrigger>
                    <DropdownMenuContent className="p-2">
                      {!checkLevel(LEVEL_2) && (
                        <>
                          {customerDetails?.partner_linked === 0 && (
                            <LinkPartner
                              contact_name={customerDetails?.full_name}
                              showLinkPartnerButton={true}
                              otherProps={{
                                contact_id: customerDetails?.id,
                              }}
                            >
                              <DropdownMenuItem
                                onSelect={(e) => e.preventDefault()}
                              >
                                <span className="text-[#333333] rounded-lg whitespace-nowrap font-inter text-sm font-medium leading-5">
                                  Link Partner
                                </span>
                              </DropdownMenuItem>
                            </LinkPartner>
                          )}
                          {customerDetails?.entity_table_id === 0 && (
                            <LinkCorporate
                              contact_name={customerDetails?.full_name}
                              showLinkPartnerButton={true}
                              otherProps={{
                                contact_id: customerDetails?.id,
                              }}
                            >
                              <DropdownMenuItem
                                onSelect={(e) => e.preventDefault()}
                              >
                                <span className="text-[#333333] rounded-lg whitespace-nowrap font-inter text-sm font-medium leading-5">
                                  Link Corporate
                                </span>
                              </DropdownMenuItem>
                            </LinkCorporate>
                          )}
                        </>
                      )}
                      <div>
                        <DocumentModal
                          fetchFn={async () => {}}
                          docs={[
                            {
                              filename: "Aadhaar Card front",
                              doc_id: 1,
                              date: customerDetails?.created_at?.toString(),
                              file: customerDetails?.aadhaar_soft_copy_front
                                ?.url,
                            },
                            {
                              filename: "Aadhaar Card back",
                              doc_id: 2,
                              date: customerDetails?.created_at?.toString(),
                              file: customerDetails?.aadhaar_soft_copy_back
                                ?.url,
                            },
                            {
                              filename: "PAN Card",
                              doc_id: 3,
                              date: customerDetails?.created_at.toString(),
                              file: customerDetails?.pan_soft_copy?.url,
                            },
                          ]}
                        >
                          <button className="flex items-center gap-2.5 py-2 px-2.5">
                            <p className="text-blue-700 font-semibold text-sm">
                              {checkLevel(LEVEL_2)
                                ? "View Documents"
                                : "Documents"}
                            </p>
                          </button>
                        </DocumentModal>
                      </div>
                    </DropdownMenuContent>
                  </DropdownMenu>
                </div>
              </div>
            </div>
            {/* for table */}
            <div className="bg-white-A700 flex-1 relative flex flex-col overflow-auto gap-2 px-4">
              <div className=" flex w-full justify-between items-center sm:px-0">
                <div className=" flex flex-col gap-2 ">
                  <Tabs
                    className="flex -mb-6 sm:-mb-2 gap-2"
                    value={pipelineType}
                    onValueChange={(value) => {
                      setActiveTab(value);
                    }}
                  >
                    <TabsList className="h-[44px] p-0">
                      {tablist.map((tab) => (
                        <TabsTrigger
                          disabled={!tab.enabled}
                          key={tab.value}
                          value={tab.value}
                          className={` py-[18px] px-6 disabled:opacity-40 text-sm h-[44px] min-w-[120px] font-semibold ${
                            tab.value === activeTab
                              ? "border-blue-700 bg-navbar-menu-bg border-t-2 text-blue-700"
                              : " text-black-label"
                          }`}
                        >
                          {tab.label}
                        </TabsTrigger>
                      ))}
                    </TabsList>
                  </Tabs>
                </div>
                {customerDetails?.status !== "blocked" ? (
                  <div className="flex gap-3 sm:hidden">
                    {!checkLevel(LEVEL_2) && (
                      <button
                        className="disabled:opacity-40 border border-blue-700 text-[#165FE3] font-semibold px-4 py-3 rounded-lg"
                        onClick={(e: any) => handleGetQuoteLead(e)}
                      >
                        Get Quote
                      </button>
                    )}
                    {!checkLevel(LEVEL_2) && (
                      <button
                        className="disabled:opacity-40 border border-blue-700 text-[#165FE3] font-semibold px-4 py-3 rounded-lg"
                        onClick={(e: any) => handleNewReferralLead(e)}
                      >
                        New Referral Lead
                      </button>
                    )}
                    <button
                      onClick={(e: any) => handleCreateLead(e)}
                      className="bg-blue-700 border border-blue-700 text-white-A700 px-4 py-3 rounded-lg"
                    >
                      {label}
                    </button>
                  </div>
                ) : (
                  <div className="flex gap-3 mt-14"></div>
                )}
              </div>
              {activeTab === "leads" && (
                <DataTable
                  columns={filteredColumns}
                  data={sortedUniqueList}
                  onRowClick={handleRowClick}
                  highlightRow={true}
                  isToolbarVisible={false}
                  isPaginationVisible={sortedUniqueList?.length > 10}
                  defaultSorting={[{ id: "id", desc: true }]}
                  pageName=""
                />
              )}
              {activeTab === "orders" && (
                <DataTable
                  columns={OrderColumns}
                  // data={OrderList}
                  data={[]}
                  onRowClick={handleRowClick}
                  highlightRow={true}
                  isToolbarVisible={false}
                  isPaginationVisible={false}
                  pageName=""
                />
              )}
            </div>
            {isRowDetailsOpen &&
              (checkLevel(LEVEL_2) ? (
                <LeadOverView
                  isOpen={true}
                  onOpenChange={setIsRowDetailsOpen}
                  rowData={selectedRowData}
                />
              ) : (
                <RowDetailsSheet
                  isOpen={true}
                  onOpenChange={setIsRowDetailsOpen}
                  rowData={selectedRowData}
                  getOpportunityList={getOpportunityList}
                />
              ))}
          </div>
        </>
      )}
    </>
  );
};

export default CustomerDetailsPage;
